























































































































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import {
  getContentType,
  getSuggestWords,
  querySearchList,
  queryWords,
  queryIdiom,
  getGrades
} from '../../../service/search'
import { addWatermarker } from '../../../utils/renderWatermarker'
import { USER_NAME } from '../../../service/constant'

@Component
export default class Test extends Vue {
  grade: number = 0
  private grades: any = {} // 年级
  get currentGrades() {
    return this.grades[this.currentContentType]
  }
  get userName() {
    return this.$store.state[USER_NAME]
  }
  renderWaterMarker() {
    const document: any = window.document
    addWatermarker(document.querySelector('.test-content'), `17题库 ${this.userName}`)
  }
  handleInputKeydown(e) {
    if (e.keyCode === 13) {
      this.data = []
      this.renderTestList(1)
    }
  }
  value = ''
  data: any[] = []
  tabBarGutter = 10
  async mounted() {
    this.contentType = await getContentType()
    this.currentContentType = this.contentType[0].type_id
    // this.value = await getDarkText()
    await this.renderTestList(1)
    this.renderWaterMarker()
    this.renderGrades()
  }
  public total: number = 0
  public pageSize: number = 10
  public current: number = 1
  public pageSizeOptions: string[] = ['10', '20', '50', '100']
  public contentType: any[] = []
  public searchValue: string = ''
  public currentContentType: string = ''
  public dataSource: any[] = []

  async renderGrades() {
    const res = await getGrades({})

    if (res.success) {
      this.grades = res.data
    }
  }

  playSoundSingleIdiom() {
    console.log('singleVoice')
    ;(this.$refs['singleIdiomVoice'] as any).play()
  }

  // 英语单词
  private word: any = {}
  private idiom: any = {}
  private audioSrc: string = ''
  get subWord() {
    return this.word.illustrativeSentenceEntext
      ? this.word.illustrativeSentenceEntext.split(this.value)
      : []
  }
  playSound(type, index) {
    if (type === 'uk') {
      console.log('uk')
      ;(this.$refs['audioUk'][index] as any).play()
    } else if (type === 'us') {
      console.log('us')
      ;(this.$refs['audioUs'][index] as any).play()
    } else if (type === 'sentence') {
      console.log('sentence')
      ;(this.$refs['audioSentence'][index] as any).play()
    }
  }
  playSoundWord(type) {
    console.log('playSoundWord')
    if (type === 'uk') {
      console.log('uk')
      ;(this.$refs['audioUkWord'] as any).play()
    } else if (type === 'us') {
      console.log('us')
      ;(this.$refs['audioUsWord'] as any).play()
    } else if (type === 'sentence') {
      console.log('sentence')
      ;(this.$refs['audioSentenceWord'] as any).play()
    }
  }
  playSoundIdiom(index) {
    console.log('play idiom')
    console.log(index)
    ;(this.$refs['audioIdiom'][index] as any).play()
  }
  async handleChange(value) {
    this.value = value
    this.data = []
    await this.handleSearch(value)
    await this.renderTestList(1)
  }
  handleTabChange(key) {
    this.currentContentType = key
    this.renderTestList(1)

    this.grade = 0
  }
  async handleSearch(content) {
    const options = {
      content,
      type: this.currentContentType
    }
    this.value = content
    this.data = await getSuggestWords(options)
  }
  async handleSubmit(e) {
    this.renderTestList(1)
  }
  private wordList: any[] = []
  private idiomList: any[] = []
  wordPagination: any = {
    current: 1,
    total: 0,
    pageSize: 10
  }
  iDiomPagination: any = {
    current: 1,
    total: 0,
    pageSize: 10
  }
  async handleWordPageChange(pagination) {
    const options = {
      page_num: pagination,
      page_size: 10,
      grade: this.grade
    }
    const res = await queryWords(options)

    if (res.success) {
      if (res.data.content) {
        this.wordList = res.data.content
      } else {
        this.wordList = []
      }
    }
  }
  async handleIdiomPageChange(pagination) {
    this.renderTestList(pagination)
  }
  wordInfo = null
  singleIdiom = null
  async renderTestList(page) {
    const type = this.currentContentType

    this.singleIdiom = null

    if (type === 'WORD') {
      // 英语单词
      this.wordPagination.current = page

      const options = this.value
        ? { content: this.value, grade: this.grade }
        : { page_num: 1, page_size: this.wordPagination.pageSize, grade: this.grade }
      const res = await queryWords(options)

      if (res.success) {
        this.word = res.data

        if (res.data.content) {
          this.wordList = res.data.content
        } else {
          if (res.data.id) {
            this.wordList = [res.data]
          } else {
            this.wordList = []
          }
        }
        this.wordPagination.total = res.data.totalElements
      }
    } else if (type === 'IDIOM') {
      // 成语
      this.iDiomPagination.current = page

      const options = {
        content: this.value,
        grade: 0,
        type: 'IDIOM',
        page_num: page,
        page_size: this.iDiomPagination.pageSize
      }
      const res = await queryIdiom(options)

      if (res.success) {
        this.idiomList = res.data
        this.iDiomPagination.total = res.total
      }
    } else {
      const options = {
        content: this.value,
        type,
        page,
        page_size: this.pageSize,
        grade: this.grade
      }
      const { list, total, word, idiom } = await querySearchList(options)
      this.dataSource = list
      this.current = page
      this.total = total
      this.wordInfo = word
      this.singleIdiom = idiom
    }
  }
  handlePageChange(page) {
    this.renderTestList(page)
  }
  onShowSizeChange(current, pageSize) {
    this.pageSize = pageSize
    this.renderTestList(1)
  }
  onShowWordSizeChange(current, pageSize) {
    this.wordPagination.pageSize = pageSize
    this.renderTestList(1)
  }
  onShowIdiomSizeChange(current, pageSize) {
    console.log('asdasd')
    this.iDiomPagination.pageSize = pageSize
    this.renderTestList(1)
  }
}
